import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0002 11.81C16 11.6111 15.9209 11.4205 15.7802 11.28L10.6402 6.14997C10.5937 6.10311 10.5384 6.06591 10.4775 6.04053C10.4165 6.01514 10.3512 6.00208 10.2852 6.00208C10.2192 6.00208 10.1538 6.01514 10.0929 6.04053C10.0319 6.06591 9.97665 6.10311 9.93017 6.14997L9.22017 6.84997C9.1733 6.89646 9.1361 6.95176 9.11072 7.01269C9.08534 7.07362 9.07227 7.13897 9.07227 7.20497C9.07227 7.27098 9.08534 7.33633 9.11072 7.39726C9.1361 7.45819 9.1733 7.51349 9.22017 7.55997L13.6702 12L9.22017 16.44C9.1736 16.4856 9.13661 16.5401 9.11135 16.6002C9.0861 16.6603 9.07309 16.7248 9.07309 16.79C9.07309 16.8552 9.0861 16.9197 9.11135 16.9798C9.13661 17.0399 9.1736 17.0944 9.22017 17.14L9.93017 17.85C9.97665 17.8968 10.0319 17.934 10.0929 17.9594C10.1538 17.9848 10.2192 17.9979 10.2852 17.9979C10.3512 17.9979 10.4165 17.9848 10.4775 17.9594C10.5384 17.934 10.5937 17.8968 10.6402 17.85L15.7802 12.72C15.919 12.5783 15.9979 12.3884 16.0002 12.19V11.81Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgRightOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgRightOutline;
